module.exports = __webpack_public_path__ + "static/media/bg_page_header.58bad3e0.png";